import { getEnv } from '@/utils'

let env = getEnv()
const baseURLMap = {
  'local': 'https://mitest.sparta.html5.qq.com',
  'development': 'https://ehcard-test.wecity.qq.com',
  'experiment': 'https://ehcard-test.wecity.qq.com',
  'production': 'https://wechat.wecity.qq.com'
}
export const baseURL = baseURLMap[env]
